// Library Imports
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import * as RiIcons from 'react-icons/ri'
import * as AiIcons from 'react-icons/ai'
import * as BiIcons from 'react-icons/bi'
import * as GiIcons from 'react-icons/gi'
import AnimatedNumber from 'react-animated-numbers'
// Asset Imports 
import '../../assets/css/stylesheets/AboutHistory.css'

function AboutHistory() {
    return (
        <>
            <Container className='about-bio-container'>
                <Row>
                    <Col>
                        <p className='about-bio-intro slide-in-left'>
                            <b>Hello and Welcome.</b>
                            We are a breed organization dedicated to the promotion and improvement of the Jersey Cattle Breed all across the United States and
                            to maintain such reacords and activities as the Association deems necessary or conducive to the best interests of the breeders of Jersey Cattle.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h1 className='about-bio-p1-header slide-in-left'>
                            JERSEY IMPROVEMENT
                            <br />
                            TO THE
                            <br />
                            <span>CORE</span>
                        </h1>
                    </Col>
                    <Col>
                        <h3 className='about-bio-p1-subheader slide-in-right'>Who We Are</h3>
                        <p className='about-bio-p1-text slide-in-right'>
                            The American Jersey Cattle Association (AJCA) was organized in 1868 and is the oldest dairy breed
                            association in the U.S. The AJCA has 1,623 active members (June, 2024) and provides services to more than 8,000
                            Jersey owners each year. The membership elects a 12-person Board of Directors plus a President. In addition to the
                            AJCA, there is National All-Jersey Inc. (NAJ) and its subsidiary, All-Jersey Sales Corporation (AJSC). NAJ, which
                            at the end of 2024 had 912 members, has its own Board of Directors. Policy, programs, and services for all three organizations are carried out by a 30-person professional staff under the direction of the Executive Secretary & Chief
                            Executive Officer.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p className='about-bio-p2-text slide-in-left'>
                            The purposes of the American Jersey Cattle Association are to improve and promote the breed of Jersey cattle in the
                            United States and to maintain such records and activities as the Association deems necessary or conducive to the best
                            interests of the breeders of Jersey cattle.
                        </p>
                        <p className='about-bio-p3-text slide-in-left'>
                            National All-Jersey Inc.’s purposes are to promote the increased production and sale of Jersey milk and milk products,
                            and to promote Jersey cattle and the interests of breeders of Jersey cattle.
                        </p>
                    </Col>
                    <Col>
                        <h1 className='about-bio-p2-header slide-in-right'>
                            EXPERIENCE
                            <br />
                            BACKED BY
                            <br />
                            <span>PURPOSE</span>
                        </h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='about-bio-section-header'>
                            <h1>Programs and Services Designed To <span>Serve</span></h1>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='about-bio-services-grid'>
                            <div className='about-bio-services-grid-column'>
                                <div className='about-bio-services-grid-panel'>
                                    <div className='about-bio-services-grid-panel-header'>
                                        <RiIcons.RiNewspaperLine className='about-bio-services-grid-panel-header-icon' />
                                        <h5>Registration</h5>
                                    </div>
                                    <div className='about-bio-services-grid-panel-seperator'></div>
                                    <p className='about-bio-services-grid-panel-text'>
                                        A total of 86,774 animals were recorded in the association’s animal database during 2024.
                                        The three-year average (2022-24) for registrations is 110,723. Since its organization in 1868 and through
                                        December 31, 2024, the AJCA has compiled pedigree records for 7,502,982 animals. Jerseys <i>(registered and unregistered)</i> comprise an estimated 14.7% of all dairy cows in the United States, and increasing at an
                                        accelerating pace. The population of Jersey cows at December 20, 2024 was estimated at 1.8 million head.
                                    </p>
                                </div>
                                <div className='about-bio-services-grid-panel'>
                                    <div className='about-bio-services-grid-panel-header'>
                                        <BiIcons.BiDna className='about-bio-services-grid-panel-header-icon' />
                                        <h5>Production And Genetic Information</h5>
                                    </div>
                                    <div className='about-bio-services-grid-panel-seperator'></div>
                                    <p className='about-bio-services-grid-panel-text'>
                                        There were 131,766 Jersey cows enrolled in AJCA
                                        performance evaluation programs at December 31, 2024, with linear type information collected from 78,959
                                        animals during the year. In 2024, 34,283 female animals were genotyped, with 964,294 genotyped males
                                        and females contributing to CDCB official evaluations through December 2024.
                                    </p>
                                </div>
                            </div>
                            <div className='about-bio-services-grid-column'>
                                <div className='about-bio-services-grid-panel'>
                                    <div className='about-bio-services-grid-panel-header'>
                                        <AiIcons.AiOutlineTag className='about-bio-services-grid-panel-header-icon' />
                                        <h5>Marketing</h5>
                                    </div>
                                    <div className='about-bio-services-grid-panel-seperator'></div>
                                    <p className='about-bio-services-grid-panel-text'>
                                        In 2024, Jersey Marketing Service, a subsidiary of NAJ, marketed
                                        nearly 1,000 live animals, plus embryos and semen for $2,178,659 through private treaty and at public auction.
                                    </p>
                                </div>
                                <div className='about-bio-services-grid-panel'>
                                    <div className='about-bio-services-grid-panel-header'>
                                        <GiIcons.GiPayMoney className='about-bio-services-grid-panel-header-icon' />
                                        <h5>Funding</h5>
                                    </div>
                                    <div className='about-bio-services-grid-panel-seperator'></div>
                                    <p className='about-bio-services-grid-panel-text'>
                                        Funding Jersey-specific research. The Jersey organizations have an endowed Research Foundation that funds
                                        competitively selected and directed research projects
                                        <br /><i>(see www.usjersey.com/programs/ResearchProgram.html)</i>.
                                        Since 1988, more than $2.0 million has been invested in research using Foundation’s resources.
                                        <br />
                                        <br />
                                        Assisting Jersey owners in finding markets that pay for the added value of Jersey milk. Market-average
                                        Jersey milk (5.0% fat, 3.8% true protein) was valued at 35% more than formula-standard milk (3.5% fat,
                                        2.9% protein) across Federal Order markets for the first three quarters of 2024. Jersey milk in orders with
                                        multiple component pricing (MCP) was valued up to 26% more than average milk.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='about-bio-section-header'>
                            <h1>Production Where It <span>Counts</span></h1>
                            <p>
                                <span>Production.</span> Jerseys produce the highest quality milk in the world. Weighing 1,050 lbs. on average, they are also
                                the most efficient converters of feed to milk. The 2024 AJCA lactation average (m.e. adjusted) for Jerseys enrolled
                                in AJCA testing programs was:
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h4>lbs. Milk</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={20719}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>lbs. Fat</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={1053}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>lbs. Protein</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={781}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>lbs. Cheese Yield</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={2671}></AnimatedNumber>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='about-bio-section-header'>
                            <h1>Estimated Yield of Manufactured Dairy Products per 100lbs. Jersey Milk</h1>
                            <p>
                                Jerseys also have the highest yield of manufactured products explaining high demand for Jersey milk
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h4>Cheddar lbs.</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={13.25}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>Cottage lbs.</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={17.29}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>Swiss lbs.</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={11.52}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>Mozzarella lbs.</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={16.48}></AnimatedNumber>
                    </Col>
                    <Col>
                        <h4>Butter</h4>
                        <AnimatedNumber
                            fontStyle={{ fontSize: 40 }}
                            includeComma
                            animateToNumber={6.25}></AnimatedNumber>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default AboutHistory